import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Dashboard } from 'styled-icons/material';
import { LogOutCircle } from 'styled-icons/boxicons-regular';
import { UserShield } from 'styled-icons/fa-solid';
import logo from '../../system/access/images/icon.png';
import defaultPersona from '../../system/access/images/default-persona.jpg';
import { palette } from '../../system/styles/styles';
import { startLogout } from '../../redux/actions/auth_actions';
import unisATSRoutes from "../../system/router";

const MainSideNav = styled.main`
  width: 100%;
  background-color: ${palette.white};
  display: grid;
  grid-template-rows: 15vh 67vh 18vh;

  .dataExtraNav {
    cursor: pointer;
    color: #aeaec1;
    text-decoration: none;
    display: grid;
    justify-content: center;
    justify-items: center;

    p {
      font-size: 14px;
      color: #aeaec1;
    }
  }

  &::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }

  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0rem;
  }

  nav {
    &::-webkit-scrollbar {
      width: 0.5em;
      height: 0em;
    }

    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0rem;
    }
  }

  .box_Logout {
    display: grid;
    justify-items: center;
    grid-auto-rows: 7vh;
    align-self: flex-end;

    img {
      width: 7vh;
      height: 7vh;
      border-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.08) 0px 3px 10px;
    }
  }

  .box_head {
    padding: 32px;
  }

  .active {
    border-right: #5373fc solid 2px;
    color: #000000 !important;

    p {
      color: #000000 !important;
    }
  }

  .Icon {
    font-size: calc(12px + 1rem);
  }

  nav {
    margin-top: 5vh;
    overflow-y: auto;

    .navigation {
      color: ${palette.black};
      display: grid;

      li {
        a {
          color: #aeaec1;
          text-decoration: none;
          display: grid;
          justify-content: center;
          justify-items: center;

          p {
            font-size: 14px;
            color: #aeaec1;
          }
        }

        justify-content: center;
        text-align: center;
        margin: 16px 0px;
      }

      button {
        font-size: 16px;
        background-color: transparent;
        color: ${palette.black};
        padding: 0;
      }
    }
  }

  .logo {
    width: 75px;
    display: table;
    margin: 0 auto;
  }

  .logotainer {
    display: table;
    margin: 32px auto 16px auto;
    background-color: ${palette.white};
    box-shadow: ${palette.lightBS};
    width: 100px;
    height: 100px;
    flex: 0 0 auto;
    border-radius: 64px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  h4 {
    font-size: 16px;
  }
`;

const SideNav = (props) => {
  const dispath = useDispatch();
  const { email, logout, typeuser, location } = props;
  const Edit = useSelector((state) => state.auth.user_nav);

  const signOut = async () => {
    await dispath(startLogout());
    logout();
  };

  return (
    <MainSideNav>
      <div className="box_head">
        <img src={logo} className="logo" alt="lapieza" />
        <br />
        <hr />
      </div>
      <nav>
        <ul className="navigation">
          <li>
            <Link to={unisATSRoutes.VACANCIES}>
              <Dashboard size="calc(12px + 1rem)" />
              <p> Vacantes </p>
            </Link>
          </li>
          <li>
            <Link to={unisATSRoutes.COMPANIES}>
              <UserShield size="calc(12px + 1rem)" />
              <p> Empresa </p>
            </Link>
          </li>
        </ul>
      </nav>

      <div className="box_Logout">
        <img
          src={Edit?.photoURL ? Edit?.photoURL : defaultPersona}
          alt=""
          style={{ cursor: 'pointer' }}
          // onClick={() => setModal(true)}
        />
        <LogOutCircle
          size="calc(12px + 1rem)"
          onClick={signOut}
          style={{ cursor: 'pointer', color: '#AEAEC1', marginTop: '10%' }}
        />
      </div>
    </MainSideNav>
  );
};

SideNav.propTypes = {
  email: PropTypes.string,
  typeuser: PropTypes.string,
  logout: PropTypes.func,
  location: PropTypes.string,
};

SideNav.defaultProps = {
  typeuser: '',
  email: '',
  logout: () => {},
  location: '',
};

export default SideNav;
